import request from './request';

export function getAnchorPublicProfile(id) {
  return request.get('/api/user/publicProfile', { params: { id } });
}

// 提交主播申请
export function submitAnchorApply({ realname, idcard, phone, reason }) {
  return request.post('/api/anchor_apply/submit', {
    realname,
    idcard,
    phone,
    reason
  });
}

// 查询本人主播申请状态
export function getAnchorApplyStatus() {
  return request.get('/api/anchor_apply/status');
}
